<section class="budget-card">
  <header>
    <h4>{{title()}}</h4>
  </header>

  <div class="budget-card__wrapper">
    @for (item of items(); track item.serviceName) {
    <div class="budget-card__wrapper__item">
      <div>
        <span>{{item.serviceName}}</span>
        <span>
          @if (item.appliedDiscount){
          <div class="--item-with-discount">
            <span>{{item.appliedDiscount}}</span>
            <span>{{item.finalPrice}}</span>
          </div>
          } @else {
          <span>{{item.finalPrice}}</span>
          }
        </span>
      </div>
      @if (item.priceWithoutTax) {
      <div class="--taxes">
        <span>{{taxLabel()}}</span>
        <span>{{item.priceWithoutTax}}</span>
      </div>
      }
    </div>
    }
  </div>

  @if (total()?.length) {
  <footer>
    <span>{{footerLabel()}}</span>
    <span class="total">{{ total() }}</span>
  </footer>
  }
</section>
